import { decodeBlurHash } from 'fast-blurhash';

onmessage = (e) => {
  const { hash, height, width } = e.data;

  if (!hash || !height || !width) return;

  const ensurePositive = (value) => Math.abs(value);
  const positiveWidth = ensurePositive(width);
  const positiveHeight = ensurePositive(height);

  const pixels = decodeBlurHash(hash, positiveWidth, positiveHeight);
  const imageData = new ImageData(pixels, positiveWidth, positiveHeight);

  postMessage({
    imageData,
    hash,
    width: positiveWidth,
    height: positiveHeight,
  });
};
